<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc_marker-1">Contents</h2>
<p class="veryfirst"><a href="#/Text/intro#toc_marker-2">Introduction</a></p>
<p class="firstleft"><a href="#/Text/ch1#toc_marker-3">1 Called to Be Saints</a></p>
<p class="body"><a href="#/Text/ch1"><i>The Need for a Compelling Theology of Holiness</i></a></p>
<p class="firstleft"><span href="#/Text/ch2#toc_marker-4" title="Link target outside of Sample">2 Union with Christ</span></p>
<p class="body"><span href="#/Text/ch2" title="Link target outside of Sample"><i>The Essence of the Christian Life</i></span></p>
<p class="firstleft"><span href="#/Text/ch3#toc_marker-5" title="Link target outside of Sample">3 Holy People Are Wise People</span></p>
<p class="body"><span href="#/Text/ch3" title="Link target outside of Sample"><i>An Invitation to Sapiential Holiness</i></span></p>
<p class="firstleft"><span href="#/Text/ch4#toc_marker-6" title="Link target outside of Sample">4 Called to Do Good Work</span></p>
<p class="body"><span href="#/Text/ch4" title="Link target outside of Sample"><i>An Invitation to Vocational Holiness</i></span></p>
<p class="firstleft"><span href="#/Text/ch5#toc_marker-7" title="Link target outside of Sample">5 Learning to Love</span></p>
<p class="body"><span href="#/Text/ch5" title="Link target outside of Sample"><i>An Invitation to Social Holiness</i></span></p>
<p class="firstleft"><span href="#/Text/ch6#toc_marker-8" title="Link target outside of Sample">6 Joy and the Ordering of the Affections</span></p>
<p class="body"><span href="#/Text/ch6" title="Link target outside of Sample"><i>An Invitation to Emotional Holiness</i></span></p>
<p class="firstleft"><span href="#/Text/appendixA#toc_marker-9" title="Link target outside of Sample">Appendix A: Congregations and Transformation</span></p>
<p class="body"><span href="#/Text/appendixA" title="Link target outside of Sample"><i>The Church and the Call to Spiritual Maturity</i></span></p>
<p class="firstleft"><span href="#/Text/appendixB#toc_marker-10" title="Link target outside of Sample">Appendix B: Christian Higher Education</span></p>
<p class="body"><span href="#/Text/appendixB" title="Link target outside of Sample"><i>A Passion for Wisdom and Spiritual Transformation</i></span></p>
<p class="firstleft"><span href="#/Text/notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/nameindex#toc_marker-11" title="Link target outside of Sample">Name Index</span></p>
<p class="firstleft"><span href="#/Text/subjectindex#toc_marker-12" title="Link target outside of Sample">Subject Index</span></p>
<p class="firstleft"><span href="#/Text/scriptureindex#toc_marker-13" title="Link target outside of Sample">Scripture Index</span></p>
<p class="firstleft"><span href="#/Text/aboutauthor#toc_marker-14" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/moreIVP#toc_marker-15" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2c66fa18